module.exports = __webpack_public_path__ + "static/media/3DPPA5.408a3c58.jpg";